<script setup lang="ts">
// Text clamped to N lines with "Show more" at the end of the last visible line
// (float trick) and "Show less" inline after the last word when expanded.
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'

const props = defineProps<{ text: string; lines: number }>()

const el = ref<HTMLElement | null>(null)
const open = ref(false)
const overflows = ref(false)
const measure = () => {
  if (el.value && !open.value) overflows.value = el.value.scrollHeight > el.value.clientHeight + 1
}
watch(() => props.text, () => nextTick(measure))
onMounted(() => { measure(); window.addEventListener('resize', measure) })
onBeforeUnmount(() => window.removeEventListener('resize', measure))
</script>

<template>
  <div class="flex">
    <p ref="el" :class="{ 'csp-clamp': !open }" :style="{ '--csp-lines': lines }">
      <button v-if="!open && overflows" type="button" class="csp-clamp-btn csp-link text-[13px]" :aria-expanded="false" @click="open = true">Show more</button>
      {{ text }}
      <button v-if="open" type="button" class="csp-link text-[13px] ml-1" :aria-expanded="true" @click="open = false">Show less</button>
    </p>
  </div>
</template>
